import getReviewList from "./getReviewList";
import createReview from "./createReview";
import getReview from "./getReview";
import changeStatus from "./changeStatus";
import updateReview from "./updateReview";
import deleteReview from "./deleteReview";

export default {
  getReviewList,
  createReview,
  getReview,
  changeStatus,
  updateReview,
  deleteReview,
};
